module.exports = __webpack_public_path__ + "static/Juster_illus_animate-7cb29d0ff41f0827187b47f21f2d3f0e.mp4";